import { useTranslation } from "@impero-com/common/utils/i18n";
import { ButtonGroup, ButtonSpec } from "@impero-com/ui";
import { UseFormReturn, useFormState } from "react-hook-form";

import { ControlProgramTagCategoryCreateFormSchema } from "../useControlProgramTagCategoryFormSchema";

interface CreateButtonsProps {
    form: UseFormReturn<ControlProgramTagCategoryCreateFormSchema>;
    onSubmit: (
        data: ControlProgramTagCategoryCreateFormSchema
    ) => Promise<void>;
    onCancelWithConfirmation: () => void;
}

export function CreateDrawerFooter({
    form,
    onSubmit,
    onCancelWithConfirmation,
}: CreateButtonsProps) {
    const { t } = useTranslation();
    const { control, handleSubmit } = form;
    const { isDirty, isSubmitting } = useFormState({ control });

    const buttons: ButtonSpec[] = [
        {
            id: "create",
            label: t("TagsList_CreateCategoryDrawer_Action_CreateCategory"),
            type: "primary",
            onClick: () => void handleSubmit(onSubmit)(),
            disabled: !isDirty,
            loading: isSubmitting,
        },
        {
            id: "cancel",
            label: t("TagsList_CreateCategoryDrawer_Action_Cancel"),
            type: "link",
            onClick: onCancelWithConfirmation,
            disabled: isSubmitting,
        },
    ];

    return <ButtonGroup buttonSpecs={buttons} />;
}
